app.directive('favoriteToggleButton', function ($http, $q, loginService, $log) {
    return {
        restrict: 'A',
        scope: {
            config: '<favoriteToggleButton'
        },
        transclude: true,
        link: function ($scope, $element, $attrs, $ctrls, $transclude) {
            var config = $scope.config;
            const stateChangeCallback = config.stateChangeCallback || function(){};
            delete $scope.config;

            if (!config || !config.id || !config.serviceUrl) {
                throw "Invalid config passed to favoriteToggleButton";
            }

            $scope.state = !!config.state;

            var currentRequest = null;

            var sendToggleRequest = function () {
                if (currentRequest !== null) {
                    return;
                }

                currentRequest = $q.defer();

                var newState = !$scope.state;

                // Tentatively switch the state so that the application feels more responsive
                $scope.state = newState;
                //stateChangeCallback($scope.state);

                $http({
                    method: 'POST',
                    url: config.serviceUrl,
                    data: {
                        'id': config.id,
                        'add': newState
                    },
                    responseType: 'json',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    timeout: currentRequest.promise
                }).then(function (httpResponse) {
                    currentRequest = null;

                    $scope.state = httpResponse.data.newState;
                    stateChangeCallback($scope.state);

                }, function (httpError) {
                    $scope.state = !newState;
                    stateChangeCallback($scope.state);

                    currentRequest = null;
                    if (httpError.xhrStatus !== "abort") {
                        $log.error(httpError);
                    }
                    if (httpError.status === 403) {
                        if (loginService.isLoggedIn === false) {
                            loginService.redirectToLoginScreen(true);
                        } else if (httpError.headers('x-profile-upgrade-url')) {
                            window.location.href = httpError.headers('x-profile-upgrade-url');
                        }
                    }
                });
            };

            var showConfirmationModal = function () {
                var modal = angular.element(config.confirmationModal);
                var confirmationButton = modal.find('button[data-modal-button="confirm"]');
                confirmationButton.attr('data-favorite-toggle-button-id', config.id);

                confirmationButton.on('click', function () {
                    if (confirmationButton.attr('data-favorite-toggle-button-id') === config.id) {
                        sendToggleRequest();
                    }
                });

                modal.modal();
            };

            $element.on('click', function ($event) {
                $event.preventDefault();

                if (config.readOnly) {
                    return;
                }

                $scope.$apply(function () {
                    if (config && config.confirmationModal && $scope.state) {
                        showConfirmationModal();
                    } else {
                        sendToggleRequest();
                    }
                });
            });

            $transclude(function (clone, childScope) {
                childScope.favoriteToggleButton = {
                    state: $scope.state
                };

                $scope.$watch('state', function (newValue) {
                    childScope.favoriteToggleButton.state = newValue;
                });

                $element.append(clone);
            });
        }
    };
});
